module.exports = __webpack_public_path__ + "static/media/System wide activites.dec658b3.png";